import sha256 from 'sha256';

const MERCHANT_ID = import.meta.env.VITE_PHONEPE_MERCHANT_ID;
const SALT_KEY = import.meta.env.VITE_PHONEPE_SALT_KEY;
const SALT_INDEX = import.meta.env.VITE_PHONEPE_SALT_INDEX;
const API_URL = 'https://api.phonepe.com/apis/hermes/pg/v1/pay';

interface PhonePePaymentOptions {
  amount: number;
  orderId: string;
  customerEmail: string;
  customerPhone: string;
  callbackUrl: string;
}

export const initiatePhonePePayment = async ({
  amount,
  orderId,
  customerEmail,
  customerPhone,
  callbackUrl
}: PhonePePaymentOptions) => {
  try {
    const payload = {
      merchantId: MERCHANT_ID,
      merchantTransactionId: orderId,
      merchantUserId: customerEmail,
      amount: amount * 100, // Convert to paise
      redirectUrl: callbackUrl,
      redirectMode: 'POST',
      callbackUrl: callbackUrl,
      mobileNumber: customerPhone,
      paymentInstrument: {
        type: 'PAY_PAGE'
      }
    };

    const base64Payload = Buffer.from(JSON.stringify(payload)).toString('base64');
    const string = `${base64Payload}/pg/v1/pay${SALT_KEY}`;
    const sha256Value = sha256(string);
    const checksum = `${sha256Value}###${SALT_INDEX}`;

    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-VERIFY': checksum
      },
      body: JSON.stringify({
        request: base64Payload
      })
    });

    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        redirectUrl: data.data.instrumentResponse.redirectInfo.url
      };
    } else {
      throw new Error(data.message || 'Payment initiation failed');
    }
  } catch (error) {
    console.error('PhonePe payment error:', error);
    throw error;
  }
};

export const verifyPhonePePayment = async (transactionId: string) => {
  try {
    const string = `/pg/v1/status/${MERCHANT_ID}/${transactionId}${SALT_KEY}`;
    const sha256Value = sha256(string);
    const checksum = `${sha256Value}###${SALT_INDEX}`;

    const response = await fetch(
      `https://api.phonepe.com/apis/hermes/pg/v1/status/${MERCHANT_ID}/${transactionId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-VERIFY': checksum,
          'X-MERCHANT-ID': MERCHANT_ID
        }
      }
    );

    const data = await response.json();
    return {
      success: data.success,
      status: data.code,
      message: data.message
    };
  } catch (error) {
    console.error('PhonePe verification error:', error);
    throw error;
  }
};